import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initTelemetry, track, EVENTS, captureException } from "@/lib/telemetry";

initTelemetry();
track(EVENTS.appOpen, { surface: "web" });

window.addEventListener("unhandledrejection", (event) => {
  captureException(event.reason ?? new Error("unhandledrejection"));
});
window.addEventListener("error", (event) => {
  if (event.error) captureException(event.error);
});

createRoot(document.getElementById("root")!).render(<App />);
